const SET_APPLIED_REPORT = 'SET_APPLIED_REPORT';
export const SET_REPORT_AND_FILTERS = 'SET_REPORT_AND_FILTERS';
const HYDRATE_APPLIED_REPORT = 'HYDRATE_APPLIED_REPORT';

export default {
    SET_APPLIED_REPORT,
    SET_REPORT_AND_FILTERS,
    HYDRATE_APPLIED_REPORT,
};
